/**
 * Hide broken card images.
 *
 * When a card image 404s, browsers fall back to rendering a broken-image
 * icon at the element's intrinsic (or alt-driven) dimensions, which can
 * blow out the parent card's layout. Scoping this to card-style images
 * means properly-loading images are untouched — the handler only fires
 * on the `error` event, never on successful loads.
 */

function hideBrokenCardImage(img) {
  const wrapper = img.closest(".card-image");
  if (wrapper) {
    wrapper.hidden = true;
    return;
  }
  img.hidden = true;
}

// Use capturing — `error` doesn't bubble.
document.addEventListener(
  "error",
  (e) => {
    const el = e.target;
    if (!(el instanceof HTMLImageElement)) return;
    if (!el.closest(".card-image")) return;
    hideBrokenCardImage(el);
  },
  true,
);

// Catch images that failed before this script ran (e.g. cached errors).
document.querySelectorAll(".card-image img").forEach((img) => {
  if (img.complete && img.naturalWidth === 0) {
    hideBrokenCardImage(img);
  }
});
